// Simply Cyndy Shop — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // --- Mobile menu toggle ---
  const toggle = document.getElementById('mobile-menu-toggle');
  const nav = document.getElementById('site-nav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // --- Add to cart with fetch (no page reload) ---
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const data = new FormData(form);
      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn ? btn.textContent : '';

      fetch('/cart/add.js', {
        method: 'POST',
        body: data
      })
      .then(res => res.json())
      .then(function () {
        if (btn) {
          btn.textContent = '✓ Added!';
          btn.style.background = 'var(--color-sage)';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.style.background = '';
          }, 2000);
        }
        // Update cart count badge
        return fetch('/cart.js');
      })
      .then(res => res.json())
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        if (btn) btn.textContent = originalText;
      });
    });
  });

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
